"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassageLearningMode = exports.PassageTaskStatus = void 0;
var PassageTaskStatus;
(function (PassageTaskStatus) {
    PassageTaskStatus[PassageTaskStatus["NOT_STARTED"] = 0] = "NOT_STARTED";
    PassageTaskStatus[PassageTaskStatus["COMPLETED"] = 1] = "COMPLETED";
    PassageTaskStatus[PassageTaskStatus["IN_PROGRESS"] = 2] = "IN_PROGRESS";
})(PassageTaskStatus || (exports.PassageTaskStatus = PassageTaskStatus = {}));
var PassageLearningMode;
(function (PassageLearningMode) {
    PassageLearningMode[PassageLearningMode["LISTEN"] = 0] = "LISTEN";
    PassageLearningMode[PassageLearningMode["READ"] = 1] = "READ";
})(PassageLearningMode || (exports.PassageLearningMode = PassageLearningMode = {}));
